import { andWhatNext } from '../../../helpers'
import Fragment from '../../../components/Fragment'
import { Fade, Typography } from '@material-ui/core'
import IconBox from './IconBox'
import useStyles from './styles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import placeholderImg from '../../../../../../assets/images/commons.png'
import Division from '../../../components/Division'

const actionButtonText = {
  email: 'Email your MP',
  petition: 'Sign the petition',
  devolved: 'Join the campaign',
  by_election: 'Join the campaign',
}

const SectionAction = ({ fragments, width, postcode, constituency }) => {
  const desktop = isWidthUp('md', width)
  const classes = useStyles({ width, desktop })
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageError, setImageError] = useState(false)
  const { has_pledged, mp_id, mp_name, mp_party } = constituency
  let { action } = constituency
  if (!action) action = 'email'
  if (action === 'email' && has_pledged) action = 'petition'

  const chunks = (chunk) => {
    const actionButton = () => (
      <Button
        color="primary"
        variant="contained"
        size="large"
        href={andWhatNext('results', { postcode, actionType: action })}
        className={classes.button}
        fullWidth={!desktop}
      >
        {actionButtonText[action]}
      </Button>
    )

    switch (chunk) {
      case 'status':
        return (
          <>
            <div className={classes.pledgeBox}>
              <IconBox good={has_pledged} />
            </div>
            <div className={classes.pledgeStatus}>
              <Typography variant="h5">
                Your MP has
                <span className={classes.pledgeHighlight}>
                  {has_pledged ? ' ' : ' NOT '}
                </span>
                taken the pledge!
              </Typography>
            </div>
          </>
        )

      case 'pledge':
        return (
          <>
            {['devolved', 'by_election'].includes(action) && (
              <>
                <Typography
                  variant="h4"
                  align={desktop ? 'left' : 'center'}
                  style={{ margin: 0 }}
                  component="div"
                >
                  <Fragment
                    title={`results_action_${action}_title`}
                    fragments={fragments}
                    merge={[{ tag: '{{constituency_name}}', content: constituency.name }]}
                  />
                </Typography>
                <Division padding={20} left={desktop} white />
              </>
            )}

            <Typography variant="body1" component="div" className={classes.pledgeIntro}>
              <Fragment
                title={`results_action_${action}${
                  action === 'by_election' ? '_' + _.snakeCase(constituency.name) : ''
                }_text`}
                fragments={fragments}
                merge={[
                  { tag: '{{constituency_name}}', content: constituency.name },
                  {
                    tag: '{{constituency_number}}',
                    content: Number(
                      constituency['poverty_stats']['number_201920'] ||
                        constituency['poverty_stats']['number_201819']
                    ).toLocaleString('en-GB'),
                  },
                  {
                    tag: '{{constituency_percent}}',
                    content: Number(
                      constituency['poverty_stats']['percentage_201920'] ||
                        constituency['poverty_stats']['percentage_201819']
                    ).toLocaleString('en-GB', { style: 'percent' }),
                  },
                ]}
              />
            </Typography>
          </>
        )
      case 'button':
        return (
          <Grid item className={classes.action}>
            {actionButton()}
          </Grid>
        )
      case 'mp':
        return (
          <Grid item className={classes.mpDetails} md={5} lg={4}>
            <Fade in={imageLoaded}>
              <img
                className={classes.mpImage}
                src={
                  mp_id && !imageError
                    ? `https://members-api.parliament.uk/api/Members/${mp_id}/Portrait?cropType=OneOne&webVersion=true`
                    : placeholderImg
                }
                alt="member of parliament"
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageError(true)}
              />
            </Fade>
            <Typography variant="h5" align="center" className={classes.mpName}>
              {mp_name}
            </Typography>
            <Typography variant="h5" align="center" className={classes.mpName}>
              {mp_party}
            </Typography>
          </Grid>
        )
      case 'facts':
        return (
          <Grid container direction="column" spacing={2} alignContent="center">
            <Grid item className={classes.facts}>
              <IconBox />
              <Typography variant="h6" style={{ color: 'white' }}>
                <b>{constituency?.poverty_stats['number_201819']} children</b> in poverty
              </Typography>
            </Grid>
            <Grid item className={classes.facts}>
              <IconBox />
              <Typography variant="h6" style={{ color: 'white' }}>
                <b>Voted against</b> free school meals
              </Typography>
            </Grid>
            <Grid item className={classes.facts}>
              <IconBox good />
              <Typography variant="h6" style={{ color: 'white' }}>
                <span className={classes.highlight}>
                  <b>Voted for </b>
                </span>
                lorem ipsum dolor blah blah
              </Typography>
            </Grid>
          </Grid>
        )
    }
  }

  if (!constituency) return null
  const noStatus = ['devolved', 'by_election'].includes(action)

  return desktop ? (
    <Grid
      container
      direction="row"
      className={classes.westminsterContainer}
      justify="center"
    >
      {chunks('mp')}
      <Grid item md={5} lg={4} style={{ position: 'relative' }}>
        {!noStatus && chunks('status')}
        {chunks('pledge')}
        {chunks('button')}
      </Grid>
    </Grid>
  ) : (
    <Grid
      container
      direction="column"
      className={classes.westminsterContainer}
      spacing={2}
    >
      <Grid item style={{ position: 'relative' }}>
        {!noStatus && chunks('status')}
        {chunks('button')}
        {chunks('mp')}
        {chunks('pledge')}
      </Grid>
    </Grid>
  )
}

export default withWidth()(SectionAction)
